module.exports = __webpack_public_path__ + "static/media/reports.13c74ba9.svg";